import React from 'react';
import {Row, Col, Alert} from 'react-bootstrap';

/**
 * Component tha'll display a message about IE not being supported on IE only.
 */
export default function TimedRedirect({
  ...props
}) {
  /**
   * Tests whether browser is IE.
   * Shamelessly copied from:
   * https://stackoverflow.com/questions/19999388/check-if-user-is-using-ie
   *
   * @returns bool
   *    Whether browser is IE or not.
   */
  function isIe() {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf("MSIE ");
    return (msie > 0 || !!navigator.userAgent.match(/Trident.*rv:11\./))
} 

  return (
    isIe() ? (
      <Row className="px-3">
        <Col>
          <Alert variant="danger">
            <Alert.Heading>Your browser is not supported</Alert.Heading>
            <p>
            It looks like you are using Internet Explorer. This browser is no
          longer supported, and we recommend you switch to a modern browser.
          We cannot guarantee correct functioning of this website in your
          current browser.
            </p>
          </Alert>
        </Col>
      </Row>
    ) : (
      null
    )
  );
}